import { FC } from 'react';

type Props = {
	className?: string;
};

const User_02_IconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				d='M4.94386 12.3365C6.32147 11.5212 8.08842 11.0415 9.9987 11.0415C11.9089 11.0415 13.6759 11.5212 15.0535 12.3365C15.7233 12.7328 16.0404 13.4585 16.0404 14.1542V16.6665C16.0404 17.0117 15.7605 17.2915 15.4154 17.2915H4.58203C4.23686 17.2915 3.95703 17.0117 3.95703 16.6665V14.1542C3.95703 13.4585 4.27408 12.7328 4.94386 12.3365Z'
				fill='inherit'
			/>
			<path
				d='M6.45703 6.24967C6.45703 4.29367 8.04269 2.70801 9.9987 2.70801C11.9547 2.70801 13.5404 4.29367 13.5404 6.24967C13.5404 8.20568 11.9547 9.79134 9.9987 9.79134C8.04269 9.79134 6.45703 8.20568 6.45703 6.24967Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default User_02_IconSolid;
